module.exports = __webpack_public_path__ + "static/media/arrow-yellow.1348f905.svg";